import { CdkAccordion } from '@angular/cdk/accordion';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, HostListener, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';

import { I18nModule } from '@spartacus/core';
import { FocusConfig, KeyboardFocusModule, LaunchDialogService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FADE_IN_CONTENT_SLIDER } from '@app/core/constants/animations.constant';
import { DpProductListService } from '@app-modules/product/product-list/services';

import { DpFacetListComponent } from '../facet-list';
import { DpProductFacetService } from '../services';

@Component({
    selector: 'dp-facet-list-panel',
    templateUrl: './facet-list-panel.component.html',
    styleUrls: ['./facet-list-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        KeyboardFocusModule,
        AsyncPipe,
        MatIcon,
        FormsModule,
        I18nModule,
        ReactiveFormsModule,
        DpFacetListComponent,
        CdkAccordion
    ],
    animations: [FADE_IN_CONTENT_SLIDER]
})
export class DpFacetListPanelComponent {
  @HostBinding('@fadeInContentSlider') animation = true;

  facetCategoryList$ = inject(DpProductFacetService).facetCategoryList$;

  selectedFacetCategoryCode$: Observable<string>;
  totalResults$ = inject(DpProductListService).model$.pipe(map((data) => data.counter.total ?? 0));

  focusConfig: FocusConfig = {
    trap: true,
    block: true,
    autofocus: 'button',
    focusOnEscape: true
  };

  readonly #launchDialogService = inject(LaunchDialogService);
  readonly #elementRef = inject(ElementRef);
  readonly #router = inject(Router);
  readonly #route = inject(ActivatedRoute);

  constructor() {
    this.selectedFacetCategoryCode$ = this.#launchDialogService.data$;
  }

  @HostListener('click', ['$event'])
  handleClick(event: PointerEvent): void {
    if ((event.target as HTMLElement).tagName === this.#elementRef.nativeElement.tagName) {
      this.onClosePanel('Cross click');
    }
  }

  onClosePanel(reason: string): void {
    this.#launchDialogService.closeDialog(reason);
  }

  onClearAllFilters(): void {
    this.#router.navigate([], { relativeTo: this.#route });
  }
}
